var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFiveStars = function SvgFiveStars(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 847 147.6",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m78 0 18.4 56.4H156l-48.2 34.8 18.4 56.4L78 112.8l-48.2 34.8 18.4-56.4L0 56.4h59.6zm172.3 0 18.4 56.4h59.6l-48.2 34.8 18.4 56.4-48.2-34.8-48.2 34.8 18.4-56.4-48.2-34.8h59.6zm173.6 0 18.3 56.4h59.3l-48 34.8 18.3 56.4-48-34.8-48 34.8 18.3-56.4-48-34.8h59.3zm172.8 0 18.4 56.4h59.6l-48.2 34.8 18.4 56.4-48.2-34.8-48.2 34.8 18.4-56.4-48.2-34.8h59.6zm172.2 0 18.4 56.4H847l-48.2 34.8 18.4 56.4-48.2-34.8-48.2 34.8 18.4-56.4L691 56.4h59.6z"
  })));
};
export default SvgFiveStars;